module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper animate fadeIn"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
  }, [_c('form', {
    staticClass: "block-border radius block shadow form--box",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      }
    }
  }, [_c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("ลืมรหัสผ่าน (เฉพาะสมัครสมาชิกด้วยอีเมลเท่านั้น)")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {}, [_c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("อีเมล")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form__text",
    class: {
      'form__input--error': _vm.$v.isError('email')
    },
    attrs: {
      "type": "email",
      "id": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.email.empty),
      expression: "$v.$errors.email.empty"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมล")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$v.$errors.email.invalid),
      expression: "$v.$errors.email.invalid"
    }],
    staticClass: "alert alert--error"
  }, [_vm._v("กรุณากรอกอีเมลให้ถูกต้อง")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--purple btn--full",
    attrs: {
      "disabled": _vm.submitting
    }
  }, [_vm._v("ส่งข้อมูล")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert--info"
  }, [_vm._v("ผู้ที่สมัครสมาชิกด้วยเบอร์โทรศัพท์กรุณาติดต่อได้ที่"), _c('br'), _vm._v("อีเมล "), _c('a', {
    attrs: {
      "href": "mailto:tcfe@ktf.premier.co.th"
    }
  }, [_vm._v("tcfe@ktf.premier.co.th")]), _c('br'), _vm._v("เบอร์โทรศัพท์ 02-301-1117")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b95c41f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForgotPassword.vue
// module id = 1063
// module chunks = 1